<template>
  <fin-scroll-carousel :items="videos">
    <template #default="{item}">
      <div>
        <fin-video-item style="{width: 300px}" :item="item" :item-height="itemHeight"/>
      </div>
    </template>
  </fin-scroll-carousel>
</template>

<script>
import FinScrollCarousel from "@/components/common/ScrollCarousel"
import FinVideoItem from "@/components/common/video/VideoItem"

export default {
  name: "fin-video-scroller",
  components: {
    FinVideoItem,
    FinScrollCarousel
  },
  props: {
    /** The list of VideoItems to display */
    videoList: {
      type: Array,
      default: () => []
    },
    /** The height of the scroller = height of video items + auto adding 2px (for borders) */
    itemHeight: {
      type: Number,
      default: 350
    },
  },
  computed: {
    videos() {
      return this.videoList.map((videoList, index) => ({videoList, id: index}))
    },
  }
}
</script>

<style scoped>

</style>
